import datapoints from './datapoints';
import setRowsFlagStateHelper from './helpers/setRowsFlagStateHelper';
import { userMailInteractionAction } from 'owa-mail-actions';
import { getStore as getListViewStore } from 'owa-mail-list-store';
import { getRowIdsFromRowKeys } from 'owa-mail-list-store';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { InstrumentationContext, selectMailStoreItemById } from 'owa-mail-store';
import flagItemService from 'owa-mail-store/lib/services/flagItemService';
import * as undoActions from 'owa-mail-undo';
import FlagType from 'owa-service/lib/contract/FlagType';
import { ActionSource, createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import flagItemsStoreUpdate, {
    ItemContext,
} from 'owa-mail-actions/lib/triage/flagItemsStoreUpdate';

const SetItemsFlagStateActionName = 'setItemsFlagState';

const setItemsFlagStateInternal = createLegacyActionWithDatapoint(
    SetItemsFlagStateActionName,
    datapoints.setItemsFlagState
)(function setItemsFlagStateInternal(
    itemIds: string[],
    instrumentationContexts: InstrumentationContext[],
    flagTypeToApply: FlagType,
    tableViewId: string,
    actionSource: ActionSource
) {
    const tableView = getListViewStore().tableViews.get(tableViewId);

    undoActions.clearLastUndoableAction();

    const itemContexts: ItemContext[] = itemIds.map(itemIdValue => {
        const item = selectMailStoreItemById(itemIdValue);

        return {
            itemId: itemIdValue,
            conversationId: item.ConversationId.Id,
        };
    });

    // Dispatch action to update the store state
    flagItemsStoreUpdate(itemContexts, flagTypeToApply, tableView.tableQuery.folderId);
    let instrumentationFlag;
    switch (flagTypeToApply.FlagStatus) {
        case 'Flagged':
            instrumentationFlag = 'Flag';
            break;
        case 'NotFlagged':
            instrumentationFlag = 'FlagCleared';
            break;
        case 'Complete':
            instrumentationFlag = 'FlagComplete';
            break;
    }
    userMailInteractionAction(instrumentationFlag, instrumentationContexts);
    const requestOptions = getMailboxInfo(tableView).requestOptions;
    return flagItemService(itemIds, flagTypeToApply, requestOptions);
});

/**
 * Set the specified flag state on a collection of items in listview table
 * @param itemRowKeys - the item row keys
 * @param tableViewId - the table view the conversations are in
 * @param flagType - the specified flag type to set
 */
export function setItemsFlagStateFromTable(
    itemRowKeys: string[],
    instrumentationContexts: InstrumentationContext[],
    tableViewId: string,
    flagTypeToApply: FlagType,
    actionSource: ActionSource,
    override?: boolean
) {
    setRowsFlagStateHelper(
        itemRowKeys,
        tableViewId,
        flagTypeToApply,
        (rowKeys: string[], flagTypeToApply: FlagType) => {
            const rowIdStrings = getRowIdsFromRowKeys(rowKeys, tableViewId);
            setItemsFlagStateInternal(
                rowIdStrings,
                instrumentationContexts,
                flagTypeToApply,
                tableViewId,
                actionSource
            );
        },
        override
    );
}

export function setItemsFlagStateFromItemIds(
    itemIds: string[],
    instrumentationContexts: InstrumentationContext[],
    flagTypeToApply: FlagType,
    tableViewId: string,
    actionSource: ActionSource
) {
    // Filter by existence in the item cache
    const filteredItemIds = itemIds.filter(itemId => !!selectMailStoreItemById(itemId));

    if (filteredItemIds.length > 0) {
        setItemsFlagStateInternal(
            filteredItemIds,
            instrumentationContexts,
            flagTypeToApply,
            tableViewId,
            actionSource
        );
    }
}
